export default __webpack_public_path__ + "static/media/marker_red.5a3c7937.svg";